import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";

class BarChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [],
      options: {},
      reload: false,
      processingTimeTooltip: false,
    };
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    const { t, title, withoutCard = false } = this.props;

    const chartContent = (
      <>
        <div className="mb-4">
          <CardTitle>{t(title)}</CardTitle>
        </div>

        <div className="mb-3">
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="bar"
            height="200"
          />
        </div>
      </>
    );

    if (withoutCard) {
      return chartContent;
    }

    return (
      <Card className="flex-grow-1 card_box_Shadow">
        <CardBody>{chartContent}</CardBody>
      </Card>
    );
  }

  componentDidMount() {
    this.buildChartState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data || prevProps.t !== this.props.t) {
      this.buildChartState();
    }

    if (prevProps.t !== this.props.t) {
      this.setState((prevState) => ({ reload: !prevState.reload }));
    }
  }

  buildChartState = () => {
    const data = this.props.data || {};
    const items = [];
    const colors = ["#00008B", "#DC143C", "#9400D3"];

    for (const key in data) {
      items.push({
        x: this.props.t(key),
        y: parseInt(data[key], 10) || 0,
      });
    }

    this.setState({
      series: [
        {
          name: "",
          data: items,
        },
      ],
      options: {
        colors,
        legend: {
          show: false,
        },
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          position: "center",
          style: {
            fontSize: "12px",
          },
          formatter: function (val) {
            return val;
          },
        },
        tooltip: {
          theme: "light",
          enabled: false,
          followCursor: true,
        },
        xaxis: {
          min: 0,
          max: 100,
        },
      },
    });
  };
}

export default withNamespaces()(BarChart);
